/**
 * Defines types for export
 */
export var EExportTypes;
(function (EExportTypes) {
    EExportTypes["CSV"] = "text/csv";
    EExportTypes["SVG"] = "image/svg";
    EExportTypes["ZIP"] = "application/zip";
})(EExportTypes || (EExportTypes = {}));
